import { createFileRoute } from "@tanstack/react-router";
import { getPublishedLegalDocument } from "@/lib/api/legal.functions";
import { LegalDocumentView } from "@/components/site/LegalDocumentView";

export const Route = createFileRoute("/terms")({
  loader: () => getPublishedLegalDocument({ data: { slug: "terms" } }),
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.metaTitle ?? "Terms of Use — KS Lau & Co" },
      {
        name: "description",
        content:
          loaderData?.metaDescription ??
          "Terms governing your use of the KS Lau & Co and Butterworth Taxation Services Sdn. Bhd. website.",
      },
      { property: "og:title", content: loaderData?.metaTitle ?? "Terms of Use — KS Lau & Co" },
      {
        property: "og:description",
        content: loaderData?.metaDescription ?? "Terms of use for the KS Lau & Co website.",
      },
    ],
  }),
  component: TermsPage,
});

function TermsPage() {
  const doc = Route.useLoaderData();
  return (
    <LegalDocumentView
      title={doc.title}
      contentHtml={doc.contentHtml}
      lastPublishedAt={doc.lastPublishedAt}
    />
  );
}
